import copy from 'copy-to-clipboard';

export default class CopyToClipboard {
	constructor() {
        this.clipBoards = document.querySelectorAll('[data-clipboard-item]');

        this.clipBoards.forEach(clipboard => {
            const clipBoardText = clipboard.querySelector('[data-clipboard-text]');
            const clipBoardButton = clipboard.querySelector('[data-clipboard-button]');

            clipBoardButton.addEventListener('click', () => {
                clipBoardButton.classList.add('is-copied');
                clipBoardText.classList.add('is-copied');
                copy(clipBoardText.textContent);
                // setTimeout(() => {
                //     clipBoardButton.classList.remove('is-copied');
                //     clipBoardText.classList.remove('is-copied');
                // }, 1000);
                clipBoardButton.blur();
            });
        });
	}
}